import "./App.scss";
import Stepper from "./components/stepper/Stepper";
import React, { Component, useState } from "react";
import Header from "./components/header/Header";
import UserForm from "./components/userform/UserForm";
import Toast from "./components/notification/Toast";
import { toast } from "react-toastify";
import MessagePanel from "./components/messagePanel/MessagePanel";

export const DEFAULT_TO_TEXT = "To";
export const DEFAULT_FROM_TEXT = "From";

const FROM_PARAM = "from";
const TO_PARAM = "to";
const GO_NEXT_PAGE_PARAM = "next";

//I have added the const below to add any dates that need to be disabled
const DISABLED_DAYS = [
    { before: new Date() }, //used to disable all dates before today
    { from: new Date(2023, 11, 12), to: new Date(2024, 0, 15) }
];

//I have added a red message panel for any notification that the end user might need to know about.
const MESSAGES = [
    { content: "Please note: Sundry vehicle drop-offs will be unavailable from 11 Dec. 2023 to 15 Jan. 2024", displayFrom: Date.parse("2023/11/20"), displayTo: Date.parse("2024/01/15") },
    { content: "Please note: Collections and deliveies to and from our Cape Town and Uitenhage depots will be unavailable untill 09 Jan 2023", displayFrom: Date.parse("2022/11/09"), displayTo: Date.parse("2023/01/09") }
];

const App = () => {

    const stepsArray = [
        "Route",
        "Vehicle",
        "Overview",
        "Client",
    ];

    const [stepperStage, setStepperStage] = React.useState(1);
    const [depotList, setDepotList] = React.useState([]);
    const [toDepotList, setToDepotList] = React.useState([]);

    const [quote, setQuote] = React.useState({});

    const [vehicleList, setVehicleList] = useState([]);

    const [selectedTo, setSelectedTo] = React.useState(DEFAULT_TO_TEXT);
    const [selectedFrom, setSelectedFrom] = React.useState(DEFAULT_FROM_TEXT);

    const [estimatePrice, setEstimatePrice] = React.useState("");

    const [formStage, setFormStage] = React.useState(1);

    const addRemoveVehicle = (vehicle, addRemove) => {
        if (addRemove === "add") {
            let newVehicleList = [...vehicleList];
            newVehicleList.push(vehicle);
            setVehicleList(newVehicleList);
            toast.success("Vehicle Added.");
        } else {
            let newVehicleList = [];
            newVehicleList = vehicleList.filter((singleVehicle) => {
                if (singleVehicle !== vehicle) {
                    return vehicle;
                }
            });
            setVehicleList(newVehicleList);
        }
    };

    // Getting the depot list.
    React.useEffect(() => {
        fetch("https://moveit.motorvia.co.za/moveit2/c/quotes/listdepots")
            .then((response) => {
                if (response.status === 200) {
                    return response.json();
                } else {
                    console.log(`${response.status}: Error looking up depot lists`);
                    return;
                }
            })
            .then((data) => {
                setDepotList(data);
                setToDepotList(data);
            })
            .catch((err) => {
                console.log("Error looking up depot lists", err);
            });
    }, []);

    React.useEffect(() => {
        var urlParams = window.location.search;
        var params;
        if (urlParams) {
            params = new URLSearchParams(urlParams);
            let fromParam = params.get(FROM_PARAM);
            let toParam = params.get(TO_PARAM);
            let goNextPage = params.get(GO_NEXT_PAGE_PARAM)?.toLocaleLowerCase();

            // Only continue once we have both from and to depot lists from the server
            if (depotList.length > 0 && toDepotList.length > 0) {
                let isInFromListTest = new RegExp(depotList.join("|"), "i");
                let isInToListTest = new RegExp(toDepotList.join("|"), "i");

                var isFromValid = isInFromListTest.test(fromParam);
                var isToValid = isInToListTest.test(toParam);

                if (isFromValid && isToValid) {
                    setSelectedFrom(fromParam);
                    setSelectedTo(toParam);
                    if ((goNextPage === "true") || (goNextPage === "on") || (goNextPage === "1")) {
                        setStepperStage(2);
                        setFormStage(2);
                    }
                }
            }
        }
    }, [depotList, toDepotList]);

    React.useEffect(() => {

        if (selectedFrom !== DEFAULT_TO_TEXT) {
            let allDepots = new Array();
            allDepots = [...depotList];
            let selectedFromIdx = depotList.indexOf(selectedFrom);
            allDepots.splice(selectedFromIdx, 1);
            setToDepotList(allDepots);
        }

        if (selectedFrom === selectedTo) {
            setSelectedTo(DEFAULT_TO_TEXT);
        }

        if (selectedFrom !== DEFAULT_FROM_TEXT && selectedTo !== DEFAULT_TO_TEXT) {
            quote.collectionLocation = selectedFrom;
            quote.deliveryLocation = selectedTo;
            fetch(`https://moveit.motorvia.co.za/moveit2/c/quotes/getprice?from=${selectedFrom}&to=${selectedTo}`)
                .then((response) => {
                    if (response.status === 200) {
                        return response.text();
                    } else {
                        console.log(`${response.status}: Cant look up price`);
                    }
                })
                .then((data) => {
                    setEstimatePrice(data);
                });
        }
    }, [selectedTo, selectedFrom]);

    return (
        <div className="background-image">

            <Header />
            <div className="stepper-container-horizontal">
                <Stepper direction="horizontal" currentStepNumber={stepperStage - 1} steps={stepsArray} stepColor="white" />
            </div>

            <UserForm depotList={depotList} toDepotList={toDepotList} selectedFrom={selectedFrom} setSelectedFrom={setSelectedFrom} selectedTo={selectedTo} estimatePrice={estimatePrice}
                setSelectedTo={setSelectedTo} stepperSetter={setStepperStage} quote={quote} vehicleList={vehicleList}
                addRemoveVehicle={addRemoveVehicle} formStage={formStage} setFormStage={setFormStage} disabledDays={DISABLED_DAYS} />
            <MessagePanel messages={MESSAGES} />
            <Toast />
        </div>
    );
};

export default App;
